var _path, _ellipse, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudyNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6083 1.43741C13.6939 1.38424 12.759 1.43564 11.8177 1.60161C5.29096 2.75245 0.932939 8.97635 2.08378 15.5031C3.23462 22.0298 9.45852 26.3878 15.9852 25.237C19.6363 24.5932 22.6087 22.3619 24.3178 19.3782C18.8919 19.0627 14.1917 15.0655 13.2069 9.48007C12.6998 6.60439 13.2622 3.7875 14.6083 1.43741Z",
    fill: "url(#paint0_linear)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 39,
    rx: 13,
    ry: 1,
    fill: "#ECECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9531 17.0753C37.4901 12.5391 33.6584 9 29 9C24.5237 9 20.8107 12.2679 20.1165 16.5481C19.316 16.1957 18.4308 16 17.5 16C13.9101 16 11 18.9102 11 22.5C11 22.5854 11.0016 22.6704 11.0049 22.755C11.0016 22.8363 11 22.9179 11 23C11 26.3137 13.6863 29 17 29H17.5H37C40.3137 29 43 26.3137 43 23C43 20.0106 40.8138 17.5319 37.9531 17.0753Z",
    fill: "url(#paint1_linear)",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 10.4504,
    y1: 1.84269,
    x2: 14.618,
    y2: 25.4781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676767",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 27,
    y1: 17,
    x2: 27,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudyNight);
export default __webpack_public_path__ + "static/media/cloudy-night.96fa29b96ce4bb6c85f201f2e31f3092.svg";
export { ForwardRef as ReactComponent };